import { Stack, Typography } from '@mui/material';
import { usePageTitle } from '../../components/shell/AppShell';
import { TerminalSessionsPanel } from './TerminalSessionsPanel';

/**
 * Oversight view of recorded remote-terminal sessions across site controllers.
 * Same panel is embedded on the Audit log. RLS-scoped server side.
 */
export default function TerminalSessionsPage() {
  usePageTitle('Terminal sessions');
  return (
    <Stack spacing={2}>
      <Typography variant="h4">Terminal sessions</Typography>
      <Typography variant="body2" color="text.secondary">
        Recorded remote-shell sessions opened against your site controllers. Every
        session is captured to immutable storage — open a row's recording to replay
        the full session output or download the log.
      </Typography>
      <TerminalSessionsPanel />
    </Stack>
  );
}
